module.exports = __webpack_public_path__ + "static/assets/96bb35bb5da9e2a531633aeabae12a4b.png";